import UserService from 'Services/user';
import HostedFields from 'Components/hosted-fields';
import BillingFields from 'Components/billing-fields';
import Paypal from 'Components/paypal';

export default {
	name: 'Subscribe',
	components: {
		HostedFields,
		BillingFields,
		Paypal
	},
	created() {
		this.vue = this;
		this.isGettingPlanInfo = true;
		this.isGettingCustomerInfo = true;
		this.isGettingClientToken = true;

		UserService.getPlanInfo(window.location.pathname.split('/').pop())
			.then(response => {
				this.plan.name = response.data.plan_name;
				this.plan.displayName = response.data.display_name;
				this.plan.monthlyPrice = response.data.m_price;
				this.plan.annualPrice = response.data.a_price;
				this.plan.priceTotal = response.data.m_price || response.data.a_price;
				this.plan.tax = '0.00';
				this.plan.taxPercent = 0;
				this.plan.currency = response.data.currency.toUpperCase();
				this.plan.trialDays = response.data.trial_days;
				this.plan.maxDevices = response.data.max_devices;
			})
			.catch(error => {
				this.errors.add({
					field: 'apierror',
					msg: error.response.data.Message
				});
			})
			.finally(() => {
				this.isGettingPlanInfo = false;
			});

		UserService.getCustomerInfo()
			.then(response => {
				this.paymentMethod = response.data.payment_method;

				this.credential.firstname = response.data.billing_address.first_name;
				this.credential.lastname = response.data.billing_address.last_name;
				this.credential.address = response.data.billing_address.address;
				this.credential.countrycode = response.data.billing_address.country_code;
				this.credential.city = response.data.billing_address.city;
				this.credential.zip = response.data.billing_address.zip;
				this.credential.company = response.data.billing_address.company;
				this.credential.vatnumber = response.data.billing_address.vat_number;

				if (this.credential.company) {
					this.billingTab.state = 'business';
				}
				this.newPayment = false;
			})
			.catch(() => {
				this.newPayment = true;
			})
			.finally(() => {
				this.isGettingCustomerInfo = false;
			});

		UserService.getClientToken()
			.then(response => {
				this.token = response.data.token;
			})
			.catch(error => {
				this.errors.add({
					field: 'apierror',
					msg: error.response.data.Message
				});
			})
			.finally(() => {
				this.isGettingClientToken = false;
			});
	},
	data() {
		return {
			vue: undefined,
			isGettingPlanInfo: true,
			isGettingCustomerInfo: true,
			isGettingClientToken: true,
			isSaving: false,
			isMerchantEnabled: process.env.FEATURE_MERCHANT === 'true',
			tabs: 'card',
			token: '',
			nonce: '',
			billingTab: {
				state: 'individual'
			},
			paymentMethod: '',
			newPayment: false,
			isBillingValid: false,
			plan: {
				name: '',
				monthlyPrice: '',
				monthlyPriceTax: '',
				tax: '',
				taxPercent: 0,
				currency: '',
				trialDays: 0,
				maxDevices: 0
			},
			credential: {
				countrycode: '',
				firstname: '',
				lastname: '',
				address: '',
				city: '',
				zip: '',
				company: '',
				vatnumber: ''
			}
		};
	},
	computed: {
		isLoading() {
			return this.isGettingPlanInfo || this.isGettingCustomerInfo || this.isGettingClientToken;
		}
	},
	methods: {
		subscribe() {
			this.errors.clear();
			this.$emit('getBillingInfo');
			this.isSaving = true;
			if (this.tabs === 'card' && this.newPayment) {
				this.$emit('tokenize');
			}
		},
		btHFError(message) {
			this.isSaving = false;
			if (message !== undefined) {
				this.errors.add({
					field: 'apierror',
					msg: 'Invalid credit card'
				});
			}
		},
		btPaypalError(message) {
			this.isSaving = false;
			if (message !== undefined) {
				this.errors.add({
					field: 'apierror',
					msg: 'Paypal error'
				});
			}
		},
		btPaypalPayload(payload) {
			this.nonce = payload.nonce;
			this.btPayload();
		},
		btHFPayload(payload) {
			this.nonce = payload.nonce;
			this.btPayload();
		},
		btPayload() {
			UserService.subscribe(this.plan.name, this.tabs, this.nonce, this.credential)
				.then(response => {
					this.$store.commit('UPDATE_SUB_INFO', {
						status: 'active',
						plan: { name: this.plan.name, trialDays: this.plan.trialDays }
					});
					this.$store.commit('UPDATE_MAX_DEVICES', this.plan.maxDevices);
					this.$ga.ecommerce.addItem({
						id: this.$store.state.user.profile.email,
						name: this.plan.name,
						price: this.plan.priceTotal
					});
					this.$ga.ecommerce.send();
					this.$router.push({ name: 'success' });
					this.isSaving = false;
				})
				.catch(error => {
					this.isSaving = false;
					this.errors.add({
						field: 'apierror',
						msg: 'Unable to subscribe'
					});
				});
		},
		billingPayload(payload) {
			this.credential = payload;
			if (!this.newPayment) {
				this.btPayload();
			}
		},
		changeToCardTab() {
			this.errors.clear();
		},
		changeToPaypalTab() {
			this.errors.clear();
			this.$emit('validateBilling');
		},
		togglePaypalButtonStatus(payload) {
			this.isBillingValid = payload;
		}
	},
	beforeDestroy() {
		this.$emit('teardown');
	}
};



// WEBPACK FOOTER //
// ./app/components/subscribe/script.js